<template>
  <div class="login-dialog-container">
    <div class="login-header">
      <h2>{{ loginTitle }}</h2>
      <p>{{ loginSubtitle }}</p>
    </div>

    <LoginForm
      :show-register-link="true"
      @show-register="showRegister = true"
      @success="handleLoginSuccess"
      @login-method-change="handleLoginMethodChange"
    />

    <!-- Register Dialog -->
    <RegisterDialog
      v-model:visible="showRegister"
      @success="handleRegisterSuccess"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import LoginForm from '@/components/auth/LoginForm.vue'
import RegisterDialog from '@/components/auth/RegisterDialog.vue'
import { useDialogStore } from '@/stores/dialogStore'

interface Props {
  onSuccess?: () => void
}

const props = defineProps<Props>()
const { t } = useI18n()

const dialogStore = useDialogStore()
const showRegister = ref(false)
const loginMethod = ref<'password' | 'sms' | 'qr'>('qr')

const loginTitle = computed(() => {
  switch (loginMethod.value) {
    case 'qr':
      return '微信扫码登录'
    case 'sms':
      return '短信验证码登录'
    case 'password':
      return '密码登录'
    default:
      return t('auth.login.title')
  }
})

const loginSubtitle = computed(() => {
  switch (loginMethod.value) {
    case 'qr':
      return '请使用微信扫描小程序码'
    case 'sms':
      return '请输入手机号和验证码'
    case 'password':
      return '请输入用户名和密码'
    default:
      return t('auth.login.subtitle')
  }
})

const handleLoginMethodChange = (method: 'password' | 'sms' | 'qr') => {
  loginMethod.value = method
}

const handleLoginSuccess = () => {
  console.log('LoginDialogContent: Login successful')
  props.onSuccess?.()

  // Wait a bit to ensure auth store state is updated
  setTimeout(() => {
    // Close the dialog after successful login
    console.log('LoginDialogContent: Closing dialog after successful login')
    dialogStore.closeDialog()
  }, 100)
}

const handleRegisterSuccess = () => {
  showRegister.value = false
  // Optionally auto-fill username from registration
}
</script>

<style scoped>
.login-dialog-container {
  width: 100%;
}

.login-header {
  text-align: center;
  margin-bottom: 30px;
}

.login-header h2 {
  color: var(--p-primary-400);
  margin: 0 0 10px 0;
  font-size: 24px;
  font-weight: 600;
}

.login-header p {
  color: #ccc;
  margin: 0;
  font-size: 14px;
}

/* 响应式设计 */
@media (max-width: 480px) {
  .login-header h2 {
    font-size: 20px;
  }
}
</style>
